<template>
    <div class="container">
        <div class="form-container">
            <div class="left">
                <div class="texto">Bienvenido/a</div>
                <form v-if="!showForgotPassword" @submit.prevent="login">
                    <label>Correo</label>
                    <input type="email" placeholder="Ingresa tu correo" v-model="email"
                        :class="{ 'input-error': emailError }" required />
                    <p v-if="emailError" class="error-message">Por favor ingresa un correo válido.</p>

                    <label>Contraseña</label>
                    <input type="password" placeholder=" ● ● ● ● ● ● ● ● " v-model="password"
                        :class="{ 'input-error': passwordError }" required />
                    <p v-if="passwordError" class="error-message">Por favor ingresa tu contraseña.</p>

                    <p v-if="loginError" class="error-message">{{ loginError }}</p>
                    <div class="link" @click="toggleForgotPassword">Olvidé mi contraseña</div>
                    <button type="submit" :disabled="loading">{{ loading ? 'Iniciando...' : 'Iniciar sesión' }}</button>
                </form>

                <form v-else @submit.prevent="sendRecoveryEmail">
                    <label>Correo para recuperación</label>
                    <input type="email" placeholder="Ingresa tu correo" v-model="recoveryEmail"
                        :class="{ 'input-error': recoveryEmailError }" />
                    <div class="link" @click="toggleForgotPassword">Volver al login</div>
                    <button type="submit">Enviar nueva contraseña</button>
                </form>
            </div>
            <div class="right">
                <img class="logoRight" src="../assets/NOLA-LOGO.png" alt="Logo" />
            </div>
        </div>

        <CambiarContrasena v-if="mostrarModalCambioContrasena" @cerrarModal="mostrarModalCambioContrasena = false" />
    </div>
</template>

<script>
import CambiarContrasena from '../components/Login/CambiarContrasena.vue';
import apiClient from '../services/apiClient';

export default {
    components: {
        CambiarContrasena,
    },
    data() {
        return {
            email: '',
            password: '',
            recoveryEmail: '',
            showForgotPassword: false,
            emailError: false,
            passwordError: false,
            recoveryEmailError: false,
            loginError: '',
            loading: false,
            mostrarModalCambioContrasena: false,
        };
    },
    methods: {
        toggleForgotPassword() {
            this.showForgotPassword = !this.showForgotPassword;
            this.loginError = '';
        },

        async login() {
            this.emailError = false;
            this.passwordError = false;
            this.loginError = '';

            if (!this.email) this.emailError = true;
            if (!this.password) this.passwordError = true;
            if (this.emailError || this.passwordError) return;

            this.loading = true;
            try {
                const response = await apiClient.post('/admin/auth/login', {
                    email: this.email,
                    password: this.password,
                });

                const { token, admin } = response.data;
                this.$store.commit('setAuth', { token, admin });
                this.$router.push('/Dashboard');
            } catch (err) {
                const msg = err.response?.data?.message;
                this.loginError = msg || 'Correo o contraseña incorrectos.';
            } finally {
                this.loading = false;
            }
        },

        async sendRecoveryEmail() {
            if (!this.recoveryEmail) {
                this.recoveryEmailError = true;
                return;
            }
            this.recoveryEmailError = false;
            alert('Función de recuperación de contraseña próximamente.');
        },
    }
};
</script>

<style scoped>
html,
body {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.container {
    padding: 50px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    background: white;
}

.form-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 1200px;
    height: 100%;
    border-radius: 15px;
    background: white;
    box-shadow: 0px 15px 30px rgb(0 0 0 / 39%);
    user-select: none;
    overflow: hidden;
}

.left {
    width: 50%;
    background: #b9b9b969;
    color: black;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding: 30px;
}

.texto {
    font-size: 36px;
    margin-top: 30px;
}

.left form {
    width: 80%;
    display: flex;
    flex-direction: column;
}

.left form label {
    font-size: 20px;
    margin-top: 20px;
}

.left form input {
    padding: 8px;
    margin-top: 5px;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    background: white;
    color: black;
    height: 30px;
}

button {
    width: 100%;
    background: black;
    color: white;
    border: none;
    padding: 12px;
    margin-top: 65px;
    cursor: pointer;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    transition: 0.3s ease;
}

button:hover {
    background: #6E44DA;
}

.right {
    width: 50%;
    background: #6E44DA;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.logoRight {
    width: 70%;
}

.link {
    margin-top: 20px;
    font-size: 14px;
    color: #0056b3;
    cursor: pointer;
    text-decoration: underline;
    align-self: flex-start;
}

.input-error {
    border: 2px solid red;
}

.error-message {
    color: red;
    font-size: 14px;
    margin-top: 5px;
}

@media (max-width: 820px) {
    .container {
        padding: 0px 50px;
        height: 90vh;
    }

    .form-container {
        flex-direction: column;
        width: 100%;
        height: auto;
    }

    .left,
    .right {
        width: 100%;
        height: auto;
        padding: 60px 0px;
    }

    .right {
        order: -1;
    }

    .texto {
        font-size: 30px;
        margin-top: 0px;
    }

    .logoRight {
        width: 40%;
    }

    .left form label {
        margin-top: 40px;
    }
}
</style>